<template>
  <span>You succesfully loged in to your dashboard</span>
</template>

<script>
  export default {
    name: 'success-login-template'
  }
</script>